import React from "react";
import { Table } from "antd";

const AlarmDatewiseReportTable = ({ tableData, loading }) => {
  const columns = [
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 300,
    },
    {
      title: "Serial Number",
      dataIndex: "serialnumber",
      key: "serialnumber",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 150,
    },
    {
      title: "Flood Alarm",
      dataIndex: "floodalarm",
      key: "floodalarm",
      render: (text, record) => {
        return text || text === "0" ? text : "NA";
      },
      width: 80,
    },
    {
      title: "Panic Alarm",
      dataIndex: "panicsituation",
      key: "panicsituation",
      render: (text, record) => {
        return text === 0 || text == null ? "0" : text;
      },
      width: 80,
    },
    {
      title: "Gas Alarm",
      dataIndex: "gasalarm",
      key: "gasalarm",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 80,
    },
    {
      title: "Smoke Alarm",
      dataIndex: "smoke",
      key: "smoke",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 80,
    },
    {
      title: "Tamper Alarm",
      dataIndex: "tamper",
      key: "tamper",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 80,
    },
    {
      title: "Total Alarm",
      dataIndex: "allalarm",
      key: "allalarm",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 80,
    },
  ];

  return (
    <>
      <Table
        dataSource={tableData}
        columns={columns}
        className="report-table"
        size="small"
        pagination={{ defaultPageSize: 50 }}
        scroll={{ x: "max-content", y: "60vh" }}
        loading={loading}
      />
    </>
  );
};

export default AlarmDatewiseReportTable;
